module.exports = __webpack_public_path__ + "LatoLatin-ThinItalic.7c534cc0e8a56ee70fbe.woff2";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-ThinItalic.woff2
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-ThinItalic.woff2
// module chunks = styles